import { getTodoList } from '../../api/workflow'

const state = {
  /** 各流程编码对应的待办数量 { [flowCode]: number } */
  todoCountByFlowCode: {}
}

const mutations = {
  SET_TODO_COUNTS(state, payload) {
    state.todoCountByFlowCode = { ...state.todoCountByFlowCode, ...payload }
  },
  SET_ONE_TODO_COUNT(state, { flowCode, count }) {
    if (flowCode != null) state.todoCountByFlowCode = { ...state.todoCountByFlowCode, [flowCode]: count }
  },
  CLEAR_TODO_COUNTS(state) {
    state.todoCountByFlowCode = {}
  }
}

const actions = {
  clearTodoCounts({ commit }) {
    commit('CLEAR_TODO_COUNTS')
  },
  /** 根据流程编码列表拉取待办数量 */
  async fetchTodoCounts({ commit }, flowCodes) {
    if (!Array.isArray(flowCodes) || flowCodes.length === 0) {
      return
    }
    const next = {}
    await Promise.all(
      flowCodes.map(flowCode =>
        getTodoList({ flowCode, page: 0, size: 1 })
          .then(res => {
            next[flowCode] = res.data && res.data.totalElements != null ? res.data.totalElements : 0
          })
          .catch(() => {
            next[flowCode] = 0
          })
      )
    )
    commit('SET_TODO_COUNTS', next)
  }
}

const getters = {
  /** 单个流程待办数 */
  todoCount: state => flowCode => {
    if (!flowCode) return 0
    return state.todoCountByFlowCode[flowCode] || 0
  },
  /** 多个流程待办总数 */
  totalTodoCount: state => flowCodes => {
    if (!Array.isArray(flowCodes)) return 0
    return flowCodes.reduce((sum, code) => sum + (state.todoCountByFlowCode[code] || 0), 0)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
